const cardValidator = require('card-validator');

/**
 * Unsopported credit card types
 */

module.exports = cardValidator;
